import { isEmpty, map } from "lodash/fp";

import {
  ApiUserIntegrationSetting,
  ApiWorkspaceIntegrationSetting,
  ConnectionHealth,
  UserIntegrationSetting,
  WorkspaceIntegrationSetting,
} from "@app/common/types/integrationSettingsTypes";
import { omit } from "@app/common/utils";
import { optionalParseUTCDateTimeFromString } from "@app/utils/utils";

const parseApiUserIntegrationSetting = ({
  connectionHealth: rawConnectionHealth,
  ...rest
}: ApiUserIntegrationSetting): UserIntegrationSetting => {
  const connectionHealth: ConnectionHealth | undefined = isEmpty(
    rawConnectionHealth
  )
    ? undefined
    : {
        ...rawConnectionHealth,
        lastSyncTime: optionalParseUTCDateTimeFromString(
          rawConnectionHealth?.lastSyncTime
        ),
      };

  return omit("userId", {
    ...rest,
    connectionHealth,
  });
};

export const parseUserIntegrationSettingsResponse = (
  response: ApiUserIntegrationSetting[]
): UserIntegrationSetting[] => map(parseApiUserIntegrationSetting, response);

const parseApiWorkspaceIntegrationSetting = (
  setting: ApiWorkspaceIntegrationSetting
): WorkspaceIntegrationSetting => {
  return omit("workspaceId", setting);
};

export const parseWorkspaceIntegrationSettingsResponse = (
  response: ApiWorkspaceIntegrationSetting[]
): WorkspaceIntegrationSetting[] => {
  return map(parseApiWorkspaceIntegrationSetting, response);
};
